import React from "react";

export default function MySQL_CASE() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_CASE</h1>
      <p>This is the MySQL_CASE component generated from the SQL JSON.</p>
    </div>
  );
}
